const helpConfiguration = {
  on_login_screen: 'Help link to display on login screen',
  on_dashboard: 'Help link to display on dashboard',
  test_link: 'Test link',
  invalid_format: 'Invalid URL format',
};

export default helpConfiguration;
